import React, { Suspense } from "react";
import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import { Link, Switch } from "react-router-dom";
import { Permissions, PermissionType } from "../../../util/Permissions";
import { CreateExchangeRate } from "./create-exchange-rate/CreateExchangeRate";
import ViewExchangeRates from "./view-exchange-rates/ViewExchangeRates";
import { UserGroupMenu } from "../../Common/layout/aside/aside-menu-lists/UserGroupMenu";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";
import { Section } from "../../Common/layout/Section";
import { Permission } from "../../Common/layout/Permission";

export default function ExchangeRateManagementPages() {

    const ExchangeRatesActions = () => <Permission permission={Permissions.EXCHANGE_RATES} permissionType={PermissionType.CREATE}>
        <div className="bg-white border-top px-4">
            <Link to="/exchange-rates/create" className={`btn btn-dark w-100 h-40 my-2 my-lg-3`}>
                Create Exchange Rate
            </Link>
        </div>
    </Permission>

    return (
        <>
            <AsideMenu>
                <UserGroupMenu destination="/exchange-rates/view" actionsMenu={ExchangeRatesActions} />
            </AsideMenu>
            <Section>
                <Suspense fallback={<LayoutSplashScreen />}>
                    <div className="py-4 px-6">
                        <Switch>
                            <ContentRoute path="/exchange-rates/create" permission={Permissions.EXCHANGE_RATES} permissionType={PermissionType.CREATE} component={CreateExchangeRate} />
                            <ContentRoute path="/exchange-rates/view/:userGroup" permission={Permissions.EXCHANGE_RATES} permissionType={PermissionType.READ} component={ViewExchangeRates} />
                        </Switch>
                    </div>
                </Suspense>
            </Section>
        </>

    );
}